module.exports = __webpack_public_path__ + "static/img/产品图@3x.e55d078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/产品图@3x.png
// module id = VVFP
// module chunks = 192